import {
	BOX_SHADOWS,
	DATA_TYPES,
	FONTS,
	PRIMARY_COLOR,
	SECONDARY_COLOR,
	THIRD_COLOR,
} from "../../constants";
import { stateType } from "../../state";

import { green } from "@material-ui/core/colors";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { addAlpha } from "../../helpers/DataHelpers";
import { formatNumber } from "../../helpers/FormatNumber";
import { BoxHeader } from "../Common/BoxHeader";
import { HelpIcon } from "../Common/ToolTipIcon";
import { Legend } from "../VariableCorrelations/DualChart";
import { BarChart, ScatterChart } from "./PredictionCharts";

const SCORE_COLOR = addAlpha(green[300], 0.4);

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		container: {
			display: "flex",
			flexDirection: "column",
			width: "100%",
			backgroundColor: "white",
			boxShadow: BOX_SHADOWS,
			borderRadius: "10px",
			transition: "1s",
			height: "700px",
		},
		scoreContainer: {
			borderColor: SCORE_COLOR,
			border: "solid",
			backgroundColor: SCORE_COLOR,
			boxShadow: `${SCORE_COLOR} 0px 1px 3px 5px;`,
			borderRadius: "10px",
			marginLeft: "15px",
			textAlign: "center",
			color: "rgba(0,0,0,0.9)",
		},
	})
);

function TotalAccuracy({ state }: stateType) {
	let colClasses = Array.from(
		Object.keys(state.saveState.modelTraining.catModelPredictions)
	);
	let totalCorrect = 0;
	let totalValues = 0;
	for (let key of colClasses) {
		let pred = state.saveState.modelTraining.catModelPredictions[key];
		totalCorrect += pred.correct;
		totalValues += pred.actualCount;
	}
	return (
		<div
			style={{
				fontFamily: FONTS,
				textAlign: "center",
				marginTop: "10px",
				fontSize: "20px",
				color: "rgba(0,0,0,0.8)",
			}}
		>
			Total Accuracy:{" "}
			<span style={{ fontWeight: "bold", color: THIRD_COLOR }}>
				{formatNumber((100 * totalCorrect) / totalValues)}%
			</span>
		</div>
	);
}

function ModelScore({ state }: stateType) {
	let classes = useStyles();
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "row",
				marginTop: "-3px",
				fontFamily: FONTS,
				fontSize: "20px",
				color: "rgba(0,0,0,1)",
				fontWeight: "bold",
				width: "80px",
			}}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					marginLeft: "auto",
				}}
			>
				<div
					className={classes.scoreContainer}
					style={{ width: "80px" }}
				>
					{Math.round(state.saveState.modelTraining.modelR2 * 100)}
				</div>
				<div style={{ marginTop: "-8px" }}>
					<HelpIcon title="This is the Model Score ranging from 0 (worst) to 100 (best). This represents how well the ML models are able to use the input variables to predict your target."></HelpIcon>
				</div>
			</div>
		</div>
	);
}

export function ModelAnalysis({ state }: stateType) {
	const classes = useStyles();
	let col = state.saveState.dataset.getColumn(
		state.saveState.modelTraining.valueToPredict
	);

	if (col === undefined) {
		return <div></div>;
	}
	return (
		<div className={classes.container}>
			<div style={{}}>
				<BoxHeader
					title={`${state.saveState.modelTraining.valueToPredict}: Predicted vs Actual Values`}
					toolTip={
						"Shows the model predictions on a subset of test data (a portion of data not used for training) vs the actual values. This give you an idea of how well the model performs."
					}
				></BoxHeader>
				<div
					style={{
						marginRight: "50px",
						marginLeft: "auto",
						display: "flex",
						justifyContent: "flex-end",
						marginTop: "-45px",
						marginBottom: "45px",
					}}
				>
					<ModelScore state={state}></ModelScore>
				</div>
			</div>
			{col.columnType === DATA_TYPES.number ? (
				<div>
					<ScatterChart
						state={{ state }}
						xData={
							state.saveState.modelTraining.modelPredictions.yTest
						}
						yData={
							state.saveState.modelTraining.modelPredictions.yHat
						}
					></ScatterChart>
					{/* <ModelScoreScatter state={state}></ModelScoreScatter> */}
				</div>
			) : (
				<div style={{ marginTop: "300px" }}>
					<Legend
						yCol={col}
						legendNames={["Actual", "Predicted"]}
						colors={[PRIMARY_COLOR, SECONDARY_COLOR]}
					></Legend>
					<BarChart
						state={{ state }}
						xData={[1]}
						yData={[1]}
					></BarChart>
					<TotalAccuracy state={state}></TotalAccuracy>
					{/* <ModelScoreCat state={state}></ModelScoreCat> */}
				</div>
			)}
		</div>
	);
}
